export default __webpack_public_path__ + "static/media/slide3.44619e47.png";